import * as z from "zod";
import { mutator } from "./mutator";

export const deleteAIBudgetSchema = z.object({
  id: z.string(),
});

export const deleteAIBudget = mutator({
  schema: deleteAIBudgetSchema,
  resolve: {
    budget: { kind: "aiBudget", from: "id" },
  },
  permissions: [
    {
      permission: "tenant:ai_providers_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, args: { budget } }) => {
    await tx.mutate.aiBudgets.delete({ id: budget.id });
  },
});
